<template>
	<div>
		<header-page title="Reglas Ats" />
		<ruleAtsForm :id="id" />
	</div>
</template>

<script>
	import ruleAtsForm from '@/components/rules-ats/rules-ats-form';

	export default {
		name: 'accounting-rule-ats-new',
		components: {
			ruleAtsForm,
		},
		props: {
			id: [Number, String],
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/atsRules/ats-rules-new.vue